import Tmx from '../lib/fp-clientlib-v4';
import { randomString } from '../helper/utils/common';
import CryptoJS from 'crypto-js';
var tmx = Tmx();
window.tmx = tmx;
export var setTmx = function setTmx() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    page_id: ''
  };
  var DOMAIN = 'rt.wisecartapp.com';
  var ORG_ID = '7prfpfvh';
  var page_id = props.page_id;
  var sesson_id = randomString(20) + new Date().getTime();
  sesson_id = CryptoJS.MD5(sesson_id).toString();
  tmx.profile(DOMAIN, ORG_ID, sesson_id, page_id);
  return sesson_id;
};